import { Commodity } from '@enmon/commons/lib/shared';
import { COMMODITY_CONFIG } from '../../../consts/commodities';

export const getPrioritizedCommodity = () =>
  Object.values(Commodity).sort((typeA, typeB) => COMMODITY_CONFIG[typeB].priority - COMMODITY_CONFIG[typeA].priority);
